import Phaser from 'phaser';

export const GameConfig = {
  WIDTH: 1280,
  HEIGHT: 720,
  TILE_SIZE: 32,

  WORLD: {
    BOUNDS: 4000,
  },

  // Player settings
  PLAYER: {
    SPEED: 200,
    SIZE: 32,
    MAX_HEALTH: 150,
    BASE_MAGNET_RANGE: 80,
    COLLISION_DAMAGE: 10,
    DAMAGE_COOLDOWN: 1000,
  },

  // Enemy settings
  ENEMY: {
    SPAWN_INTERVAL: 3000, // milliseconds (balanced for performance and gameplay)
    SPEED: 90,
    SIZE: 24,
    MAX_PER_WAVE: 5
  },

  PICKUPS: {
    MAX_PICKUPS: 50,
    HEALTH_PICKUP_CHANCE: 0.08,
    POWERUP_PICKUP_CHANCE: 0.03,
    MAX_GEMS: 40,
    EXP_GEM_VALUE: 25,
    HEALTH_PICKUP_VALUE: 20,
  },

  // Weapon settings
  WEAPON_DATA: {}
} as any;

export const phaserConfig: Phaser.Types.Core.GameConfig = {
  type: Phaser.AUTO,
  width: GameConfig.WIDTH,
  height: GameConfig.HEIGHT,
  physics: {
    default: 'arcade',
    arcade: {
      gravity: { x: 0, y: 0 },
      debug: false
    }
  },
  backgroundColor: '#2d2d2d',
  scale: {
    mode: Phaser.Scale.FIT,
    autoCenter: Phaser.Scale.CENTER_BOTH
  }
};
